// The ground's camera pans the column so the beat's focus element sits in
// the band the beat can show (spec §4, §7.2, §7.4): below whatever docks
// at the top (the caption and the door label below xl; from xl nothing
// docks over the column, so the stage's own top) and above the line the
// next page's top reaches when the beat's scrub completes — for beat 01,
// the sheet's lip at rest, the only moment that beat is read. Up when the
// focus hangs below that line, down when the caption would cover it: the
// least pan that fits, or top-aligned under the caption when nothing fits.
const PAD = 16

// The focus's top in the stage's untransformed space. The focus and the
// column carry the same (applied or in-flight) translate, so their rect
// difference is the focus's depth in the column; adding the untransformed
// stage's top places it where it would sit with no pan. Measuring the
// focus directly would feed the previous pan back into the next one.
export function focusTopInColumn(
    focusRectTop: number,
    columnRectTop: number,
    stageRectTop: number
): number {
    return focusRectTop - columnRectTop + stageRectTop
}

export function cameraOffset(
    focusTop: number,
    focusHeight: number,
    under: number,
    floor: number
): number {
    const bandTop = under + PAD
    const bandBottom = floor - PAD
    const focusBottom = focusTop + focusHeight
    if (focusTop >= bandTop && focusBottom <= bandBottom) return 0
    if (focusTop < bandTop || focusHeight > bandBottom - bandTop) {
        return focusTop - bandTop
    }
    return focusBottom - bandBottom
}
